export type ProductModuleSlug = "cleaning" | "serwis" | "flota" | "administracja" | "home";

export const CLEANING_UI_ROLES = ["owner", "coordinator", "cleaner"] as const;

export type CleaningUiRole = (typeof CLEANING_UI_ROLES)[number];

export function isCleaningUiRole(role: string | null | undefined): boolean {
  if (!role) return false;
  return (CLEANING_UI_ROLES as readonly string[]).includes(role.trim().toLowerCase());
}

type ModuleAccessRpcClient = {
  rpc: (
    fn: "user_has_module_access",
    args: { p_module_slug: string },
  ) => PromiseLike<{ data: boolean | null; error: { message: string } | null }>;
};

export async function userHasModuleAccess(
  client: unknown,
  moduleSlug: ProductModuleSlug,
): Promise<boolean> {
  const rpcClient = client as ModuleAccessRpcClient;
  const { data, error } = await rpcClient.rpc("user_has_module_access", {
    p_module_slug: moduleSlug,
  });
  if (error) {
    console.error("[moduleAccess] user_has_module_access:", error.message);
    return false;
  }
  return data === true;
}
